import React, { useContext } from "react";
import {
    Button,
    ButtonGroup,
    HStack,
    Spacer,
    Stack,
} from "@chakra-ui/react";
import { H3 } from "../../../common/components/Texts";
import ContentContext from "../../../common/context/ContentContext";
import SaveButton from "../../Content/components/SaveButton";
import CloseButton from "../../Content/components/CloseButton";

interface OwnProps {
    title: string | React.ReactNode;
    onSave: () => void;
    isSaving: boolean;
    onCloseWithAutosave?: () => void;
};

const Header = ({
    title,
    isSaving,
    onSave,
    onCloseWithAutosave,
}: OwnProps) => {
    const content = useContext(ContentContext);
    return (
        <>
            <Stack
            direction={['column', 'row']}
                alignItems="center"
                justifyContent="space-between"
                marginRight={6}
            >
                { typeof title === "string" && <H3 text={title} /> }
                { typeof title !== "string" && title }
                <Spacer />
                <HStack>
                    <ButtonGroup spacing={2}>
                        <SaveButton isSaving={isSaving} onSave={onSave} />
                        <Spacer />
                        {content && content.subject && (
                            <CloseButton onCloseWithAutosave={onCloseWithAutosave} />
                        )}
                    </ButtonGroup>
                </HStack>
            </Stack>
        </>
    );
};

export default Header;
